import type { ReactNode } from 'react';
import {
  GuestActionGateProvider,
  type GuestProviderContactGateParams,
} from '@/shared/hooks/useGuestActionGate';
import { useGuestSignupModal } from './GuestSignupModalContext';
import { useUnauthRumAction } from '../hooks/useUnauthRumAction';

const getEntityType = (providerType: GuestProviderContactGateParams['providerType']) =>
  providerType === 'FINANCIAL_ADVISOR' ? 'financial_advisor' : 'service_provider';

export const PreLoginGuestActionGateProvider = ({ children }: { children: ReactNode }) => {
  const { openModal } = useGuestSignupModal();
  const trackAction = useUnauthRumAction();

  const openProviderContactGate = ({
    providerId,
    providerType,
  }: GuestProviderContactGateParams) => {
    trackAction('unauth.action_button_click', {
      action: 'profile_contact',
      entityType: getEntityType(providerType),
      entityId: providerId,
    });
    openModal({
      trigger: 'action_button_click',
      triggerEntityId: providerId,
      providerType,
    });
  };

  return (
    <GuestActionGateProvider value={{ openProviderContactGate }}>
      {children}
    </GuestActionGateProvider>
  );
};
